import React, { useState } from "react";
import close from "../../assets/icons/close.svg";
import { Postdata } from "../../API/GlobalApi";
import Notifier from "../../Utils/notify";
import Session from "../../Utils/Sessions";
import '../../assets/css/Modal.css';
import { useFocusTrap } from "../../Utils/TabIndexingFocus";
import ConfirmationModal from "./ConfirmationModal";

export const AddPenalityInFeeScheduledFee = ({ isOpen, onClose }) => {


    const trapRef = useFocusTrap(isOpen);
    // ---------------- STATES ----------------
    const [penaltyPerDay, setPenaltyPerDay] = useState("");
    const [maxPenalty, setMaxPenalty] = useState("");
    const [startDate, setStartDate] = useState("");

    const [loading, setLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    // ---------------- HANDLE SUBMIT ----------------
    const handleSubmit = async () => {
        if (!penaltyPerDay || !maxPenalty || !startDate) {
            Notifier("error", "Please fill all fields");
            return;
        }

        const payload = {
            penalty_per_day: Number(penaltyPerDay),
            max_penalty: Number(maxPenalty),
            penalty_start_date: startDate,
            created_by: Session.userId // if required
        };

        try {
            // setLoading(true);
            const response = await Postdata("fees/penalty/add", payload);

            // if (response?.status) {
            //     Notifier("success", "Penalty added successfully");
            //     onClose();
            // } else {
            //     Notifier("error", response?.message || "Something went wrong");
            // }
        } catch (err) {
            console.error(err);
            Notifier("error", "Server error");
        } finally {
            setLoading(false);
        }
    };

    const isFormValid = penaltyPerDay !== "" && maxPenalty !== "" && startDate !== "";


    if (!isOpen) return null;
    return (
        <>


            <div className="modal-overlay">
                <div
                    className="modal-content recevingPaymentBody"
                    style={{
                        position: "relative",
                        width: "40%",
                        display: "flex",
                        flexDirection: "column",
                        overflowY: "auto",
                        minHeight: "40vh",
                        maxHeight: "80vh",
                        height: 'auto',
                        padding: "20px",
                    }}

                    ref={trapRef}
                >

                    {/* Header */}
                    <div
                        className="modal-header-content"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                        }}

                    >
                        <h2 className="text-primary">Update Penalty</h2>
                        <button className="close-btn" onClick={onClose}>
                            <img src={close} alt="close" />
                        </button>
                    </div>

                    {/* Body */}
                    <div style={{ flex: 1 }}>
                        <div className="row mt-3 d-flex justify-content-center gap-3">

                            {/* Penalty per day */}
                            <div className="col-md-10">
                                <label className="form-labell mb-1">Penalty per day in (₹)<span className="astrisk">*</span></label>
                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    value={penaltyPerDay}
                                    onChange={(e) => {
                                        let value = e.target.value;

                                        if (/^\d{0,5}(\.\d{0,2})?$/.test(value) || value === "") {
                                            setPenaltyPerDay(value);
                                        }
                                    }}
                                    className="form-control penalityInput"
                                    placeholder="Penalty per day"
                                />
                                <small className="text-muted">Penalty must not exceed the max amount</small>
                            </div>

                            {/* Maximum penalty */}
                            <div className="col-md-10">
                                <label className="form-labell mb-1">Maximum penalty amount (up to ₹) </label>
                                <input
                                    type="number"
                                    step="0.01"
                                    value={maxPenalty}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        if (value === "") {
                                            setMaxPenalty("");
                                            return;
                                        }

                                        if (/^\d{0,5}(\.\d{0,2})?$/.test(value)) {
                                            setMaxPenalty(value);
                                        }
                                    }}
                                    className="form-control penalityInput"
                                    placeholder="Maximum penalty"
                                />
                            </div>

                            {/* NEW FIELD: Penalty Start Date */}
                            <div className="col-md-10">
                                <label className="form-labell mb-1">Penalty Start From<span className="astrisk">*</span></label>
                                <input
                                    type="date"
                                    className="form-control penalityInput"
                                    value={startDate}
                                    min={new Date().toISOString().split("T")[0]}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </div>

                        </div>
                    </div>

                    {/* Footer */}
                    <div style={{ display: 'flex', justifyContent: 'end', marginTop: "10px" }}>
                        <button
                            className="add-btn"
                            disabled={!isFormValid || loading}
                            onClick={() => setShowConfirm(true)}

                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",

                                // cursor changes based on validity/loading
                                cursor: !isFormValid || loading ? "not-allowed" : "pointer",

                                // background color changes based on validity/loading
                                backgroundColor: !isFormValid || loading ? "#d3d3d3" : "#7F56DA",
                            }}
                        >
                            {loading ? (
                                <span className="spinner-border spinner-border-sm" role="status" />
                            ) : (
                                "Set Penalty & Sent Reminder"
                            )}
                        </button>

                    </div>

                </div>
            </div>
            <ConfirmationModal
                isOpen={showConfirm}
                title="Confirm Penalty Update"
                message="Are you sure you want to set this penalty and send reminder?"
                onConfirm={() => {
                    setShowConfirm(false);
                    handleSubmit();   // call actual submit after confirmation
                }}
                onCancel={() => setShowConfirm(false)}
                showCheckbox={false}
                isSubmitting={loading}
            />

        </>
    );
};
